import { lazy } from 'react'
import AuthRoute from './authentication'

// ** Document title
const TemplateTitle = '%s - AVDHAAN'

// ** Default Route
const DefaultRoute = '/all-project'

// if (localStorage.getItem('userData')) {
//   const navigation = JSON.parse(localStorage.getItem('userData')).access
//   console.log('Navigation .....')
//   console.log(navigation)
// } else {
//   console.log('Not Logged in ...')
// }

/**
 * ONE lazy component shared by every route that renders the project shell.
 *
 * These routes used to call lazy(() => import('../../pages')) separately. Each lazy() call
 * creates its own component type with its own private promise state, so navigating between
 * two of them (e.g. HES > Command History -> Push Data) handed React a different type at the
 * same position: it tore down the whole matched subtree, then suspended because that second
 * lazy had never resolved before. Suspense fallback={null} is what painted the page white,
 * and the remount re-ran every mount effect underneath. Once resolved, the lazy stopped
 * suspending, which is why each tab only misbehaved on its first visit.
 *
 * Sharing one instance keeps the type stable across those navigations, so React updates the
 * subtree instead of remounting it and there is nothing left to suspend on.
 */
const ProjectModule = lazy(() => import('../../pages'))

// ** Merge Routes
const AcessRoutes = [
  ...AuthRoute,
  {
    path: '/all-project',
    component: lazy(() => import('../../pages/allProject'))
  },
  {
    path: '/admin',
    component: lazy(() => import('../../pages/userAcessPanel'))
  },
  {
    // Not under /:category/:project/:module: the tracker covers every project at once, so it
    // has no project of its own to sit inside.
    path: '/ssl-tracker',
    component: lazy(() => import('../../pages/sslTracker'))
  },
  // {
  //   path: '/notification',
  //   component: lazy(() => import('../../pages/GasDistribution/module/Notification'))
  // },
  // {
  //   path: '/:category/:project/:module/:pss',
  //   component: lazy(() => import('../../views/module'))
  // },,

  {
    path: '/:category/:project/:module',
    component: ProjectModule
  },
  {
    path: '/:category/:project/:module/maps/:mapType',
    component: lazy(() => import('../../pages/GasDistribution/module/Dashboard/Maps/MapsWrapper'))
  },
  {
    path: '/:category/:project/:module/rtc',
    component: lazy(() => import('../../pages/GasDistribution/module/Dashboard/RTC'))
  },
  {
    path: '/:category/:project/:module/meter-profile/:meterId',
    component: lazy(() => import('../../pages/GasDistribution/module/Hes/MeterProfile/MeterProfileDetail'))
  },
  {
    path: '/:category/:project/:module/push-data',
    component: ProjectModule
  },
  {
    path: '/:category/:project/:module/meter-profile',
    component: ProjectModule
  },
  // {
  //   path: '/:category/:project',
  //   component: lazy(() => import('../../views/project'))
  // },
  {
    path: '/error',
    component: lazy(() => import('../../components/CustomComponent/error')),
    layout: 'BlankLayout'
  },
  {
    path: '/no',
    component: lazy(() => import('../../components/CustomComponent/notAuthorised')),
    layout: 'BlankLayout'
  }
]

export { DefaultRoute, TemplateTitle, AcessRoutes }
